package io.eqoty.secretk.types.proto

sealed class MsgProto